import { AvcInvoicesAction, GET_AVC_INVOICES, GET_AVC_INVOICES_HIERARCHY_SUCCESS, GET_AVC_INVOICES_ERROR, GET_AVC_INVOICES_SUCCESS } from '../actions/actions-avc-invoices';
import { InvoiceDownloadAPI } from '../../../../../redux/models/invoices/invoice-download-api';

export const AVC_INVOICES_REDUCER = 'avcInvoicesReducer';

export interface AvcInvoicesState {
  isLoading: boolean;
  loadingError: string;
  avcInvoices: Map<string, InvoiceDownloadAPI.IInvoiceResponse[]>;
  avcInvoicesHierarchy: InvoiceHierarchyItem[];
}

export interface InvoiceHierarchyItem {
  officeId: string;
  companyName: string;
}

export const avcInvoicesInitState: AvcInvoicesState = {
  isLoading: true,
  loadingError: '',
  avcInvoices: new Map<string, InvoiceDownloadAPI.IInvoiceResponse[]>(),
  avcInvoicesHierarchy: []
};

/* eslint-disable */
export function reducersAvcInvoices(state = avcInvoicesInitState, action: AvcInvoicesAction): AvcInvoicesState {
  switch (action.type) {
    case GET_AVC_INVOICES:
      return { ...state, isLoading: true, loadingError: '' };

    case GET_AVC_INVOICES_SUCCESS:
      state = { ...state, isLoading: false, loadingError: '' };
      state.avcInvoices.set(action.officeId, action.payload);
      return state;

    case GET_AVC_INVOICES_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    case GET_AVC_INVOICES_HIERARCHY_SUCCESS:
        state = { ...state, avcInvoicesHierarchy: action.invoiceHierarchy };
        return state;

    default:
      return state;
  }
}
